import React from "react";
import { Helmet } from "react-helmet";
import HeaderDefault from "../../../components/header/HeaderDefault";
import CopyRight from "../../../components/footer/copyright/CopyRight";
import Footer from "../../../components/footer/Footer";
import ServiceList from "../../../components/list/ServiceList";
import ServiceFaq from "../../../components/faq/ServiceFaq";
import Skills from "../../../components/skill/Skills";
import DigitalMarketingApproach from "../../../components/service/DigitalMarketingApproach";
import CounterThree from "../../../components/counter/CounterThree";
import ImageGridFour from "../../../components/image-grid/ImageGridFour";
import DigitalMarketingProcess from "../../../components/service/DigitalMarketingProcess";

const DigitalMarketingService = () => {
    return (
        <div>
            <Helmet>
                <title>Multi Cloud Ai - Digital Marketing</title>
            </Helmet>
            {/* End Page SEO Content */}

            <HeaderDefault />
            {/* End Header */}

            <div className="ptf-main">
                <div className="ptf-page ptf-page--service-detail">
                    <section>

                        <div className="container-xxl">
                            <div className="row">
                                <div className="col-xl-9">
                                    {/* <!--Animated Block--> */}

                                </div>
                                <div
                                    className="ptf-animated-block"
                                    data-aos="fade"
                                    data-aos-delay="0"
                                >
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                                    ></div>
                                    <h1 className="large-heading2 text-center"
                                    >Best Digital Marekting Company</h1>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                                    ></div>
                                    <p className="fz-18 my_background" >
                                        We are brilliant on-line advancing office that advances and
                                        lifts organizations in a proficient means and makes relationship between your possible clients/crowd
                                        and your business. We are notable for our incredibly focused on and result-situated computerized media
                                        advancing administrations as well as SEO, Social media advancing, Content advancing, Email advancing,
                                        Social advertisements, Google promotions, belittling arrangements. Additionally, thinking of a blend
                                        and special innovation that gives the best outcome from portable and responsive web style to look
                                        and online media crusades. when we start work on any task, our exceptionally prepared and approved
                                        experts investigate everything concerning the business, expected crowd, contenders to advertise
                                        business cost-actually. arrangements. </p>

                                    <ImageGridFour />

                                </div>
                                {/* <!--Spacer--> */}
                                <div
                                    className="ptf-spacer"
                                    style={{ "--ptf-xxl": "5rem" }}
                                ></div>
                                <div
                                    className="ptf-animated-block"
                                    data-aos="fade"
                                    data-aos-delay="0"
                                >
                                    <h4>Result Oriented Agency And ROI Based Digital Marketing Services For
                                        Your Business Growth</h4>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "1.5rem" }}
                                    ></div>
                                    <p className="fz-18 my_background" >
                                        We've a group of thoroughly prepared, ensured and extreme
                                        computerized advancing advisors, content scholars and illustrations architects. They are focused,
                                        committed and creative and place flawlessness into every movement to encourage the most
                                        straightforward outcome. As a main Digital Marketing Agency, we give sensible advanced advancing
                                        bundles and have assisted a wide range of ventures with loving inns, travel, schooling focuses,
                                        administration providers, creators, little organizations and so on to achieve their arranged targets.
                                        Our advisors have brilliant information concerning the latest advancements, search calculations and
                                        apparatuses that work with United States to orchestrate the straightforward techniques for your
                                        business development. when it includes online media advancing and content advancing, we tend to
                                        break down every one of the latest patterns ,watchword look and conjointly style top notch
                                        connecting with web-based media creative to accomplish the predefined result.</p>
                                </div>
                                {/* <!--Spacer--> */}
                                <div
                                    className="ptf-spacer"
                                    style={{ "--ptf-xxl": "5rem" }}
                                ></div>
                                <div
                                    className="ptf-animated-block"
                                    data-aos="fade"
                                    data-aos-delay="0"
                                >
                                    <h4>Why You Should Choose Digital Marketing Company?</h4>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "1.5rem" }}
                                    ></div>
                                    <p className="fz-18 my_background" >
                                        We have assembled the ability to advance brands by utilitarian online media apparatuses and systems. Online media is a significant piece of our
                                        lives and the best likely option for showcasing. We have the expected web-based media apparatuses to permit you to arrive at possible clients
                                        what's more, increment brand perceivability by cooperating with them. We are the best advanced showcasing office to assist you with prospering your
                                        business on the web.</p>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* Top Portion */}

                    {/* <!--Spacer--> */}
                    <div
                        className="ptf-spacer"
                        style={{ "--ptf-xxl": "6rem" }}
                    ></div>


                    <div
                        className="ptf-animated-block"
                        data-aos="fade"
                        data-aos-delay="0"
                    >
                        <h4 style={{ marginLeft: "20px" }}>
                            Digital Marketing Solutions We Provide</h4>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "1.5rem" }}
                        ></div>
                        <div className="fz-18 my_background" style={{ marginLeft: "20px" }}>
                            <ul>
                                <li>Certified and experienced team, always ready to support.</li>
                                <li>Highly targeted, result-oriented and data-oriented social media and Google Ads campaigns.</li>
                                <li>Excellent knowledge about the technologies and algorithms.</li>
                                <li>Original and attractive content to promote products and services.</li>
                                <li>Proper and timely reporting of improvements, changes, insights etc.</li>
                                <li>Clients reviews and appreciations.</li>
                                <li>Strong knowledge about marketing platforms.</li>
                                <li>Usage of advanced and well-known tools.</li>
                                <li>Only use genuine SEO techniques to avoid ranking-related issues.</li>
                                <li>Work for client satisfaction.</li>
                                <li>Increase your traffic and generate leads for both B2B & B2C spaces.</li>
                            </ul>
                        </div>
                    </div>
                    <div
                        className="ptf-spacer"
                        style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                    ></div>
                    <section
                        className="has-accent-1-background"
                        style={{
                            backgroundImage: `url("/assets/img/root/service-bubble.png")`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "100% calc(100% + 120px)",
                        }}
                    >
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                        ></div>
                        <div className="container-xxl">
                            {/* <!--Animated Block--> */}
                            <div
                                className="ptf-animated-block"
                                data-aos="fade"
                                data-aos-delay="1"
                            >
                                <h1 className="has-white-color large-heading">Experties in Digital Marketing</h1>
                            </div>
                            {/* <!--Spacer--> */}
                            <div
                                className="ptf-spacer"
                                style={{ "--ptf-xxl": "7.5rem", "--ptf-md": " 3.75rem" }}
                            ></div>
                            <DigitalMarketingApproach />
                        </div>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "10rem", "--ptf-md": "5rem" }}
                        ></div>
                    </section>

                    <section>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "5.625rem", "--ptf-md": "2.8125rem" }}
                        ></div>
                        <div className="container-xxl">
                            <div className="row">
                                <div className="col-xl-8">
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h2>Best Digital Marketing Service We Offer</h2>
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "4.375rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h4>SEO (Search Engine Optimization)</h4>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>
                                        <p className="fz-18 my_background">
                                            Web index improvement This strategy amplifies the perceivability of web destinations
                                            and furthermore assists with asking a superb position on web crawlers. Assuming an individual looks for
                                            a specific item or administration and he gets your business site in prime outcome, he/she can visit your
                                            site. We improve the whole site by playing On-page and Technical SEO and to ask a good position our group
                                            plays out every one of the pertinent exercises of Off-page SEO. Website optimization additionally further
                                            develops the voyager expertise. We improve the whole site by playing On-page and Technical SEO and to
                                            encourage a nice position our group plays out every one of the applicable exercises of Off-page SEO.
                                            Web optimization additionally further develops the voyager expertise. We upgrade the whole site by playing
                                            On-page and Technical SEO and to encourage a fair position our group plays out every one of the applicable
                                            exercises of Off-page SEO. Website
                                            optimization likewise further develops the voyager mastery.
                                        </p>
                                    </div>

                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "4.375rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h4>Social Media Marketing</h4>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>
                                        <p className="fz-18 my_background ">
                                            This kind of advancing is valuable for every business and a
                                            significant stockpile of creating reasonable quality leads. With regards to disparagement or drawing
                                            in a pristine crowd for the business, we tend to square quantify the best. Our online media experts
                                            dissect each knowledge of web-based media and make techniques upheld making arrangements for web-based
                                            media development. we tend to conjointly deal with the form quality crowd, imaginative planning, use
                                            of exploration based hash-labels and so on we give specially made web-based media showcasing plans to
                                            any or all types of organizations. At computerized advertising , we offer our significant objective
                                            improving brand cost and communicating OK happy techniques to advance client's administrations or
                                            product. we tend to try and have the skill to run.
                                        </p>
                                    </div>

                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "4.375rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h4>Google Adwords — PPC</h4>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>
                                        <p className="fz-18 my_background">
                                            PPC (pay per click) is that the speediest gratitude to gather quality
                                            leads. Our experts run outcome arranged Google Ads and focus on the area, orientation, interest-based
                                            crowd to ask extra quality outcomes. Our guaranteed PPC experts have radiant information in regards to
                                            look through promoting, show publicizing, remarketing and looking advertisements. also, furthermore
                                            ready to utilize the spending plan successfully.
                                            {/* <!--Spacer--> */}
                                            <div
                                                className="ptf-spacer"
                                                style={{ "--ptf-xxl": "0.5rem" }}
                                            ></div>
                                            We give the best ROI through our appropriately
                                            arranged Google promotions crusades. Our group moreover offers complete Google looking efforts to
                                            draw in web customers and visitors.
                                        </p>
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "4.375rem" }}
                                    ></div>
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h4>Content Marketing</h4>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>
                                        <p className="fz-18 my_background">
                                            Content is the best source to share the business' message
                                            to the crowd. We have encountered content journalists who compose the substance after the legitimate
                                            investigation and utilize the watchwords to get the best position Our substance showcasing
                                            specialists use every one of the exercises to advance the substance, for example, article posting,
                                            visitor post, infographic sharing and so on to advance the substance or business Our substance
                                            advertising specialists use every one of the exercises to advance the substance such as article
                                            posting, visitor post, infographic sharing and so forth to promote the substance or business.
                                        </p>
                                    </div>

                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "3.125rem" }}
                                    ></div>
                                    <div
                                        className="row"
                                        style={{
                                            "--bs-gutter-x": "3.75rem",
                                            "--bs-gutter-y": "7.5rem",
                                        }}
                                    >
                                        <CounterThree />
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "6.875rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h3>Our Skills</h3>
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "3.75rem" }}
                                    ></div>
                                    <div className="ptf-skill-box-grid">
                                        <Skills />
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "6.875rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h2>Our Working Process</h2>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>

                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "5.625rem" }}
                                    ></div>
                                    {/* <!--Process Steps--> */}
                                    <DigitalMarketingProcess />
                                </div>
                                <div className="col-xl-4">
                                    <div className="ptf-sidebar ptf-sidebar--right">
                                        {/* <!--Widget--> */}
                                        <div className="ptf-widget ptf-widget-services-list">
                                            {/* <!--Animated Block--> */}
                                            <div
                                                className="ptf-animated-block"
                                                data-aos="fade"
                                                data-aos-delay="0"
                                            >
                                                <h4 className="ptf-widget-title">Services List</h4>
                                                <ServiceList />
                                            </div>
                                        </div>
                                        {/* <!--Widget--> */}
                                        <div className="ptf-widget ptf-widget-faq">
                                            {/* <!--Animated Block--> */}
                                            <div
                                                className="ptf-animated-block"
                                                data-aos="fade"
                                                data-aos-delay="0"
                                            >
                                                <h4 className="ptf-widget-title">FAQs</h4>
                                                <ServiceFaq />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "6.25rem", "--ptf-md": "3.125rem" }}
                        ></div>
                    </section>
                    {/* End .main content with sidebar */}
                </div>
                {/* End .ptf-page */}
            </div>
            {/* End ptf-main */}

            {/*=============================================
             Start Footer
             ============================================== */}
            <footer className="ptf-footer ptf-footer--style-1">
                <div className="container-xxl">
                    <div className="ptf-footer__top">
                        <Footer />
                    </div>
                    <div className="ptf-footer__bottom">
                        <CopyRight />
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default DigitalMarketingService;
